import { Builder } from 'components/minute/builders/v2/Builder';
import { useDirectMarkerUpdates } from 'components/minute/builders/v2/useDirectMarkerUpdates';
import { useCreateWorldMarkerV2 } from 'hooks/marker/v2/useCreateWorldMarkerV2';
import { useContext } from 'react';
import { CtxEdit } from 'session/ctxEdit';

export const LineBuilder = () => {
    const ctxEdit = useContext(CtxEdit);
    const createWorldMarkerV2 = useCreateWorldMarkerV2();
    const directMarkerUpdates = useDirectMarkerUpdates();

    return (
        <Builder
            updateMarkerDirectly={directMarkerUpdates.updateLine}
            shouldBeClosedPolygon={false}
            createWorldMarker={(coordinate) => {
                const marker = createWorldMarkerV2.createLine(coordinate.lat, coordinate.lng);
                return { markerId: marker.id };
            }}
            onFinished={(marker) => {
                ctxEdit.markerCreation.finish(marker);
            }}
        />
    );
};
